//引入接口文档
import req from '@/utils/req.js'

//用户集合分组新增修改
export function saveUserList(params) {
  return req.post("/biz/user-list-group123",params);
}

//用户集合分组表详情
export function userListDetail(params) {
  return req.get(`/biz/user-list-group/${params}`);
}

//用户集合分组表分页
export function pageUserList(params) {
  return req.get("/biz/user-list-group/page",params);
}

//用户分组明细表分页
export function pageUserDetailList(params) {
  return req.get("/biz/user-list-group-detail/page",params);
}


//集合修改
export function groupEdit(params) {
  return req.put("/biz/user-list-group",params);
}







//运营消息 消息事件列表
export function pageOperateList(params) {
  return req.post("/biz/operational-msg/event-page",params);
}

//运营消息列表
export function pageOperationalList(params) {
  return req.post("/biz/operational-msg/page",params);
}

//运营消息列表删除
export function operationalDelete(params) {
  return req.get(`/biz/operational-msg/${params.id}`);
}

//运营消息列表启用停用
export function operationalState(params) {
  return req.put("/biz/operational-msg/state",params);
}


//运营消息添加
export function operationalAdd(params) {  
  return req.post("/biz/operational-msg",params,{loading: true});
}
//运营消息修改
export function operationalEdit(params) {
  return req.put("/biz/operational-msg",params,{loading: true});
}

//运营消息 消息事件详情
export function eventDetail(params) {
  return req.get(`/biz/operational-msg/event/${params.id}`);
}

//运营消息列表详情
export function operationalDetail(params) {
  return req.get(`/biz/operational-msg/${params.id}`);
}

//运营消息发送记录
export function recordPage(params) {  
  return req.post("/biz/operational-msg/record-page",params);
}

//运营消息发送记录数据
export function recordCount(params) {  
  return req.post("/biz/operational-msg/record-group-count",params);
}


//运营消息推荐渠道数据
export function channelList(params) {  
  return req.post("/biz/operational-msg/channel-list",params);
}



